const getters = {
  stepIndex: state => state.org.stepIndex,
  stepStatus: state => state.org.stepStatus,
  toolTip: state => state.org.toolTip,

  token: state => state.user.token,
  routerList: state => state.user.routerList,
  userInfo: state => state.user.userComInfo,
  navList: state => state.user.navList,

  // 导航栏下标处理
  navIndex: state => state.publics.navIndex,
  publicityIndex: state => state.publics.publicityIndex,
  provinceList: state => state.publics.provinceList,

  // 搜索名称
  comName: state => state.publics.comName
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js